
import { i18nText } from '@/locales';
import { RouterNameEnum } from '@/router/router.types';
import { RouterProperties } from '@/router/routerProperties';
export const SettingsRoutes = [
    {
        path: '/Settings',
        redirect: '/Settings/index',
        meta: {
            auth: true,
        },
        component: (): any => import('@/UI/layouts/MainLayout.vue'),
        children: [
            {
                path: 'company', name: 'CompanyProfile',
                meta: {alias: RouterNameEnum.Settings, title: i18nText('Профиль компании'), breadcrumb: [{name: i18nText('Настройки'), link: RouterNameEnum.Settings}, {name: i18nText('Профиль компании')}]},
                component: (): any => import('@/UI/pages/Settings/Company.vue'),
            },
            {
                path: 'subscription', name: 'CompanySubscription',
                meta: {alias: RouterNameEnum.Settings, title: i18nText('Подписка компании'), breadcrumb: [{name: i18nText('Настройки'), link: RouterNameEnum.Settings}, {name: i18nText('Подписка компании')}]},
                component: (): any => import('@/UI/pages/Settings/Subscription.vue'),
            },
            {
                path: 'index/:Studio?',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("настройки EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки") }
                    ],
                },
                name: RouterNameEnum.Settings,
                component: (): any => import('@/UI/pages/Settings/Index.vue'),
            },
            {
                path: 'users/:Studio',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("настройки пользователя EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), support: ['studioselect'], link: "Settings" },
                        { name: i18nText("Пользователи") }
                    ],
                    props: {
                        source: {
                            root: "settingsUser",
                            name: "settingsUser",
                            items: "users",
                            item: "usersItems",
                            routePage: RouterNameEnum.SettingsUsersPage,
                        },
                    },
                },
                name: RouterNameEnum.SettingsUsers,
                component: (): any => import('@/UI/pages/Settings/Users/Index.vue'),
            },
            {
                path: 'users/:Studio/page/:page/:total/:filter',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("настройки пользователя EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), support: ['studioselect'], link: "Settings" },
                        { name: i18nText("Пользователи") }
                    ],
                    props: {
                        source: {
                            root: "settingsUser",
                            name: "settingsUser",
                            items: "users",
                            item: "usersItems",
                            routePage: RouterNameEnum.SettingsUsersPage,
                        },
                    },
                },
                name: RouterNameEnum.SettingsUsersPage,
                component: (): any => import('@/UI/pages/Settings/Users/Index.vue'),
            },
            {
                path: 'role_and_access/:Studio?',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("роли и права доступа EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), support: ['studioselect'], link: "Settings" },
                        { name: i18nText("Роли и права доступы") }
                    ],
                },
                props: { source: RouterProperties.settingsRoles },
                name: RouterNameEnum.SettingsRolesAndAccess,
                component: (): any => import('@/UI/pages/Settings/Users/RolesAndAccess.vue'),
            },
            {
                path: 'finances/payment',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("настройки оплаты EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), link: "Settings" },
                        { name: i18nText("Настройки оплаты") }
                    ],
                },
                props: { source: RouterProperties.settingsFinance },
                name: RouterNameEnum.SettingsFinancePayment,
                component: (): any => import('@/UI/pages/Settings/Finance/Payment.vue'),
            },
            {
                path: 'categories/visits',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("категории записей EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), link: "Settings" },
                        { name: i18nText("Категории записей") }
                    ],
                },
                props: { source: RouterProperties.settingsCategories },
                name: RouterNameEnum.SettingsCategoriesVisits,
                component: (): any => import('@/UI/pages/Settings/Categories/Visits.vue'),
            },
            {
                path: 'categories/source',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("Источники записей EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), link: "Settings" },
                        { name: i18nText("Источники") }
                    ],
                },
                props: { source: RouterProperties.settingsCategoriesSource },
                name: RouterNameEnum.SettingsCategoriesSource,
                component: (): any => import('@/UI/pages/Settings/Source/SourceMain.vue'),
            },
            {
                path: 'categories/clients',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("категории пользователей EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), link: "Settings" },
                        { name: i18nText("Категории клиентов") }
                    ],
                },
                props: { source: RouterProperties.settingsCategories },
                name: RouterNameEnum.SettingsCategoriesClients,
                component: (): any => import('@/UI/pages/Settings/Categories/Clients.vue'),
            },
            {
                path: 'site/services',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("настройки пользователя EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), link: "Settings" },
                        { name: i18nText("Услуги") }
                    ],
                },
                props: { source: RouterProperties.settingsSite },
                name: RouterNameEnum.SettingsSiteServices,
                component: (): any => import('@/UI/pages/Settings/Site/Services.vue'),
            },
            {
                path: 'site/services/edit/:id',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("настройки услуг EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), link: "Settings" },
                        { name: i18nText("Услуги"), link: "SettingsSiteServices" },
                        { name: i18nText("Редактирование услуги") }
                    ],
                },
                props: { source: RouterProperties.settingsSite },
                name: RouterNameEnum.SettingsSiteServicesEdit,
                component: (): any => import('@/UI/pages/Settings/Site/ServicesEdit.vue'),
            },
            {
                path: 'site/news',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("настройки пользователя EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Настройки"), link: "Settings" },
                        { name: i18nText("Новости") }
                    ],
                },
                props: { source: RouterProperties.settingsSite },
                name: RouterNameEnum.SettingsSiteNews,
                component: (): any => import('@/UI/pages/Settings/Site/News.vue'),
            },
            {
                path: 'site/vacancy',
                meta: {
                    alias: RouterNameEnum.Settings,
                    title: i18nText("настройки пользователя EPILIER"),
                    // breadcrumb: [{ name: 'Настройки / Настройки сайта / Вакансии' }],
                },
                props: { source: RouterProperties.settingsSite },
                name: RouterNameEnum.SettingsSiteVacancies,
                component: (): any => import('@/UI/pages/Settings/Site/Vacancy.vue'),
            },
        ],
    },
];
